import { render, staticRenderFns } from "./ViewMaterialsTransferred.vue?vue&type=template&id=a27e8324&scoped=true"
import script from "./ViewMaterialsTransferred.vue?vue&type=script&lang=js"
export * from "./ViewMaterialsTransferred.vue?vue&type=script&lang=js"
import style0 from "./ViewMaterialsTransferred.vue?vue&type=style&index=0&id=a27e8324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e8324",
  null
  
)

export default component.exports